import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Sidebar.css";

function Sidebar() {
  const location = useLocation();
  const role = localStorage.getItem("userRole");
  
  // Get initial state from localStorage or default to expanded
  const [isCollapsed, setIsCollapsed] = useState(() => {
    const saved = localStorage.getItem("sidebarCollapsed");
    return saved ? JSON.parse(saved) : false;
  });

  // Save state to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem("sidebarCollapsed", JSON.stringify(isCollapsed));
    // Update main content margin
    const mainContent = document.querySelector(".main-content");
    if (mainContent) {
      if (isCollapsed) {
        mainContent.style.marginLeft = "60px";
      } else {
        mainContent.style.marginLeft = "245px";
      }
    }
  }, [isCollapsed]);

  const toggleSidebar = () => {
    setIsCollapsed(!isCollapsed);
  };

  let menuItems = [];


  if (role === "admin") {
    menuItems = [
      { path: "/", label: "Dashboard", icon: "📊" },
      { path: "/audio-management", label: "Audio Management", icon: "🔊" },
      { path: "/general-audios", label: "General Audios", icon: "🎵" },
      { path: "/components", label: "Components", icon: "🧩" },
      { path: "/chat-bot", label: "Chat Bot", icon: "💬" },
      { path: "/voice-chat-bot", label: "Voice Chat Bot", icon: "🎤" },
      { path: "/regression-tests", label: "Regression Tests", icon: "🧪" },
      { path: "/outbound-calls", label: "Workflows", icon: "📞" },
      { path: "/database-config", label: "Database Config", icon: "🗄️" },
      // { path: "/db-compare", label: "DB Compare", icon: "🔍" },
      { path: "/database-comparer", label: "Database Comparer", icon: "📉" },
      { path: "/prod-utilities", label: "Prod Utilities", icon: "⚙️" },
      { path: "/v3-workflow", label: "V3 Workflow", icon: "🔄" },
      { path: "/metadata-group", label: "Meta data group", icon: "📋" }
    ];
  }

  if (role === "dinesh") {
    menuItems = [
      { path: "/outbound-calls", label: "Outbound Calls", icon: "📞" }
    ];
  }

  return (
    <aside className={`sidebar ${isCollapsed ? "collapsed" : ""}`}>
      <button className="sidebar-toggle" onClick={toggleSidebar} title={isCollapsed ? "Expand Sidebar" : "Collapse Sidebar"}>
        <span className="breadcrumb-icon">☰</span>
      </button>
      <nav className="sidebar-nav">
        {menuItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className={`nav-item ${location.pathname === item.path ? "active" : ""
              }`}
            title={isCollapsed ? item.label : ""}
          >
            <span className="nav-icon">{item.icon}</span>
            {!isCollapsed && <span className="nav-label">{item.label}</span>}
          </Link>
        ))}
      </nav>
    </aside>
  );
}

export default Sidebar;
